import { membersApi } from "@services/apiMembersClient";
import {
  CreateOfferInput,
  CreateOfferOutput,
  DeleteOfferByIdInput,
  DeleteOfferByIdOutput,
  GetOfferByIdInput,
  GetOfferByIdOutput,
  GetOfferInput,
  GetOfferOutput,
  UpdateOfferByIdInput,
  UpdateOfferByIdOutput,
} from "@_types/offers";
import { ResponsePaginationType } from "@_types/shared";
import { AxiosPromise } from "axios";

export const createOffer = ({ ...data }: CreateOfferInput): Promise<CreateOfferOutput> => {
  return membersApi.post("/offers", { ...data });
};

export const getOffer = (params: GetOfferInput): AxiosPromise<ResponsePaginationType<GetOfferOutput>> => {
  return membersApi.get("/offers", { params });
};

export const deleteOfferById = ({ uuid }: DeleteOfferByIdInput): Promise<DeleteOfferByIdOutput> => {
  return membersApi.delete(`/offers/${uuid}`);
};

export const getOfferById = ({ uuid }: GetOfferByIdInput): Promise<GetOfferByIdOutput> => {
  return membersApi.get(`/offers/${uuid}`);
};

export const updateOfferById = ({ offerUuid, ...data }: UpdateOfferByIdInput): Promise<UpdateOfferByIdOutput> => {
  return membersApi.patch(`/offers/${offerUuid}`, { ...data });
};
